import React from 'react';
export const CallToAction = () => {
  return <section className="w-full bg-white py-16 pb-8" data-id="element-25">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-26">
        <div className="flex flex-col items-center" data-id="element-27">
          {/* New text box replacing the LIMITED-TIME OFFER box */}
          <div className="text-center mb-8 w-full max-w-md" data-id="element-28">
            <p className="text-2xl font-semibold mb-4" data-id="element-29">
              It's easy to see why Zenora keeps selling out again and again.
            </p>
            <p className="text-xl font-semibold mb-4" data-id="element-30">
              Where can I get a Zenora Smart Ring?
            </p>
            <p className="text-lg" data-id="element-31">
              Zenora Smart Rings are sold exclusively on zenora.shop to ensure
              you always get genuine quality and the latest features. Right now,
              the company is offering a limited-time 40% discount + free
              shipping for all new customers on their official site.
            </p>
          </div>
          <div className="w-full max-w-md mx-auto mb-8" data-id="element-32">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g1RdnEJmwY2CZgAVDKdS6k/sectiona15_img1-3_%281024_x_1024_px%29.jpg" alt="Zenora Smart Ring" className="rounded-lg shadow-xl w-full max-w-md" data-id="element-33" />
          </div>
          <div className="border border-gray-300 bg-blue-50 p-6 rounded-lg mb-8 w-full max-w-md text-left" data-id="element-34">
            <p className="font-semibold mb-4" data-id="element-35">
              PLEASE NOTE: As a special online exclusive offer, the
              company is giving all new customers 40% Off + Free Worldwide
              Shipping for a limited time.
            </p>
            <p className="mb-4" data-id="element-36">
              This deal may end at any moment due to high demand and limited
              stock—act now to secure your discount before it's gone.
            </p>
            <p className="mb-4" data-id="element-37">
              Plus, if you don't absolutely love your Zenora Smart Ring, you can
              return it within 30 days for a full refund—no questions asked.
            </p>
            <p className="mb-4" data-id="element-38">
              Zenora continues to sell out thanks to its trusted,
              subscription-free health insights. We strongly recommend claiming
              this exclusive offer while supplies last.
            </p>
            <p data-id="element-39">
              Please check availability now to see if your size is still in
              stock.
            </p>
          </div>
          {/* Updated button text and increased font size */}
          <a href="https://zenora.shop/products/zenora-smart-ring" className="bg-amber-400 hover:bg-amber-500 text-black font-bold py-4 px-8 text-2xl w-full max-w-md transition-colors text-center block border border-amber-600 shadow-md" data-id="element-40">
            Check Availability
          </a>
          {/* Modified text - removed period and made bold */}
          <div className="mt-2 text-center text-sm text-gray-600 max-w-md font-bold" data-id="element-41">
            Click the link above to see if the 40% off + free shipping offer is
            still in stock
          </div>
        </div>
      </div>
    </section>;
};